import React, { useState, useEffect } from "react";
import { getSummonerProfileContext } from "components/SummonerProfiles/SummonerProfileContext";
import { useSummonerProfile } from "api/summonerProfileApi";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

const PlayedWithUser = (props) => {
  const { wins, losses, count, region, user } = props;

  const getSummonerIcon = (summoner) => {
    const { getProfileIconImg } = getRiotAssetsContext();
    const { data: profileData } = useSummonerProfile(region, summoner, {}, "");
    if (!profileData) {
      return null;
    }
    const { profileInit, fetchProfileRanks } = profileData;
    const { playerInfo, memberStatus, lastModified } = profileInit || {};
    const { iconId } = playerInfo || {};
    return getProfileIconImg(iconId);
  };

  return (
    <a href={"/lol/profile/" + region + "/" + user} className="player-link">
      <div className="player-container">
        <div className="user">
          <img src={getSummonerIcon(user)} className="profile-icon" />
          <div className="profile-link">{user.length > 13 ? user.slice(0, 13).concat("...") : user}</div>
        </div>
        <div>{count}</div>
        <div>
          {wins} - {losses}
        </div>
        <div>{Math.round((wins / (wins + losses)) * 100)}%</div>
      </div>
    </a>
  );
};

const RecentlyPlayedWith = (props) => {
  const { matchSummariesRPW } = props;
  const [recentPlayers, setRecentPlayers] = useState([]);
  const [region, setRegion] = useState("");
  const context = getSummonerProfileContext();
  const { summonerName } = context;

  const getRecentPlayers = (matchSummariesRPW) => {
    let recentPlayersData = {};
    let targetTeam;
    for (const set of matchSummariesRPW) {
      for (const game of set) {
        let targetTeam = game["teamA"];
        for (const user of game["teamB"]) {
          if (user["summonerName"].toLowerCase() === summonerName) {
            targetTeam = game["teamB"];
          }
        }
        for (const duo of targetTeam) {
          if (duo["summonerName"].toLowerCase() !== summonerName) {
            if (!(duo["summonerName"] in recentPlayersData)) {
              recentPlayersData[duo["summonerName"]] = {
                wins: game["win"] ? 1 : 0,
                losses: game["win"] ? 0 : 1,
                count: 1,
              };
            } else {
              game["win"]
                ? (recentPlayersData[duo["summonerName"]]["wins"] += 1)
                : (recentPlayersData[duo["summonerName"]]["losses"] += 1);
              recentPlayersData[duo["summonerName"]]["count"] += 1;
            }
          }
        }
      }
    }
    const firstSort = Object.keys(recentPlayersData).map((key) => [key, recentPlayersData[key]]);
    const sortedByCount = Object.fromEntries(firstSort.sort((a, b) => b[1]["count"] - a[1]["count"]).splice(0, 8));
    return sortedByCount;
  };

  const getRegion = (matchSummariesRPW) => {
    return matchSummariesRPW[0][0]["regionId"];
  };

  useEffect(() => {
    if (matchSummariesRPW && matchSummariesRPW[0].length > 0) {
      setRecentPlayers(getRecentPlayers(matchSummariesRPW));
      setRegion(getRegion(matchSummariesRPW));
    } else {
      setRecentPlayers([]);
      setRegion(null);
    }
  }, [matchSummariesRPW]);

  return (
    <div className="content-section rpw-container">
      <div className="rpw-container_header">
        <div className="title">
          <div className="bluebar" />
          <span>Recently Played With</span>
        </div>
        <p>Last {matchSummariesRPW ? Object.keys(matchSummariesRPW).length * 20 : 20} games</p>
      </div>
      <div className="content-description">
        <div> Summoner </div>
        <div> Played </div>
        <div> W - L </div>
        <div> Win Ratio </div>
      </div>
      <div className="rpw-content">
        {!matchSummariesRPW ? (
          <div style={{ marginBottom: "30px", marginTop: "30px" }}>
            <div className="spinthatshit-loader">
              <div className="spinner"></div>
            </div>
          </div>
        ) : recentPlayers.length !== 0 ? (
          Object.keys(recentPlayers).map((key) => (
            <PlayedWithUser
              key={key}
              wins={recentPlayers[key]["wins"]}
              count={recentPlayers[key]["count"]}
              losses={recentPlayers[key]["losses"]}
              region={region}
              user={key}
            />
          ))
        ) : (
          <h1 className="no-games">No Recently Played With</h1>
        )}
      </div>
    </div>
  );
};

export default RecentlyPlayedWith;
